/**
 * DevBanner — matches Next.js DevBanner which returns null.
 * The Next.js version is a no-op; this mirrors that behavior.
 */
export default function DevBanner() {
  return null
}
